/* FAQ category scroll-spy. Loaded by sections/faq.liquid. */
(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  /* ---------- FAQ category scroll-spy (.faq__cats a[href^="#"]) ---------- */
  function initFaqSpy(root) {
    $$('.faq__cats', root).forEach(function (nav) {
      var links = $$('a[href^="#"]', nav);
      var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      if (!targets.length || !('IntersectionObserver' in window)) return;
      function activate(id) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); }); }
      links.forEach(function (a) { a.addEventListener('click', function () { activate(a.getAttribute('href').slice(1)); }); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) activate(en.target.id); });
      }, { rootMargin: '-10% 0px -70% 0px' });
      targets.forEach(function (t) { io.observe(t); });
    });
  }

  /* A #handle link (the product-code "Read more") opens that answer. The id is the metaobject handle. */
  function openHashedFaq() {
    var raw = (location.hash || '').slice(1);
    if (!raw) return;
    var id;
    try { id = decodeURIComponent(raw); } catch (e) { id = raw; }
    var el = document.getElementById(id);
    if (!el) return;
    var node = el;
    while (node) {
      if (node.tagName === 'DETAILS') node.open = true;
      node = node.parentElement;
    }
  }

  window.theme.register(function (root) {
    initFaqSpy(root);
    openHashedFaq();
  });
  window.addEventListener('hashchange', openHashedFaq);
})();
